import { render, staticRenderFns } from "./MonthlyClaimsDashboard.vue?vue&type=template&id=4ce4d294&scoped=true"
import script from "./MonthlyClaimsDashboard.vue?vue&type=script&lang=js"
export * from "./MonthlyClaimsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MonthlyClaimsDashboard.vue?vue&type=style&index=0&id=4ce4d294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4d294",
  null
  
)

export default component.exports